/**
 * Tile growth — rolling windows from days since last meeting.
 * Easy to tune via GROWTH_THRESHOLDS.
 */

export const GROWTH_THRESHOLDS = {
  /** Met within the last 7 days */
  weekDays: 7,
  /** Met within the last ~30 days */
  monthDays: 30,
  /** Met within the last ~90 days */
  quarterDays: 90,
  /** Met within the last ~365 days */
  yearDays: 365,
  // Beyond yearDays → older
};

/** Healthiest → least recent */
export const TILE_STATES = ["week", "month", "quarter", "year", "older"];

/**
 * @param {{ lastMetAt: string | null, eventCount?: number, now?: Date }} input
 * @returns {"week"|"month"|"quarter"|"year"|"older"}
 */
export function computeTileState({ lastMetAt, now = new Date() }) {
  if (!lastMetAt) return "older";

  const last = new Date(lastMetAt);
  if (Number.isNaN(last.getTime())) return "older";

  const days = daysBetween(last, now);
  const t = GROWTH_THRESHOLDS;

  if (days <= t.weekDays) return "week";
  if (days <= t.monthDays) return "month";
  if (days <= t.quarterDays) return "quarter";
  if (days <= t.yearDays) return "year";
  return "older";
}

export function daysBetween(from, to = new Date()) {
  const a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
  const b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
  return Math.floor((b - a) / 86_400_000);
}

export function daysSinceLabel(lastMetAt, now = new Date()) {
  if (!lastMetAt) return "never";
  const days = daysBetween(new Date(lastMetAt), now);
  if (days <= 0) return "today";
  if (days === 1) return "1 day";
  return `${days} days`;
}

export function formatShortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export function initials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
